//styles
import './Header.css'

const Header = () => {
    return(
        <header className = "header">
            <img 
                src = "https://i.imgur.com/XF9AvmC.png" 
                alt = "rick-and-morty-app logo"
                className = "header__logo"
            />
        </header>
    )
}
export default Header